(function($){
	//Only run if there's a filter form on the page
	if ($("#filter-form").length) {

		//Append sorting if there is a sort select
		if ($('#sort-select').length) {

			//Set initial values
			setOrder();

			//Listen for changes
			$('#sort-select').change(function(e) {

				function capitalize_Words(str) {
				 	return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
				}

				// Change all option values to capitalize
				$('#sort-select option').each(function(){
					var text = $(this).text().toLowerCase();
					$(this).text(capitalize_Words(text));
				})

				//Set new values
				setOrder();

				//Reset the page
				$('#paged').val(1);

				//Submit the form
				$('#filter-form').trigger('submit');
			});

			function setOrder() {

				// Change option text to uppercase
				var text = $('#sort-select option:selected').text();
				text = text.toUpperCase();
				$('#sort-select option:selected').text(text);

				//Get the current sort option
				let $selected = $('#sort-select option:selected');

				$('#order').val($selected.attr('data-order'));
				$('#orderby').val($selected.attr('data-orderby'));
			}
		}

		//Add secret filter if there is a secret filter
		if ($('#secret-filter').length) {
			let $secret = $('#secret-filter');

			$("#filter-form").append('<input type="hidden" name="'+$secret.attr('data-taxonomy')+'" value="'+$secret.attr('data-term')+'">');
		}

		//Handle the mobile menu toggling
		$(".filter-taxonomy select").each(function() {
			$(this)
				.attr('multiple', 'multiple')
				.attr('name', $(this).attr('name')+'[]')
				.selectize({
	                plugins: ['remove_button']
	            });
		});

		//Update the results count and pagination, if it exists
		$(document).on('filterComplete', function(e, query) {
			//Rsult count
			$('#result-count').html(query.found_posts);

			//Search page items
			if ($('#hero-result-count').length) {
				let val = $('#keyword-filter').val();

				$('#hero-result-count').html(query.found_posts);
				$('#hero-query').html(val);

				//Update querystring
				history.replaceState({}, document.title, window.location.href.split('?')[0] + '?s=' + encodeURI(val));
			}

			//Scroll to top of results if you are lower down
			if ($('html').scrollTop() > $('#results-column').offset().top) {
				$('html').animate({
					scrollTop: $('#results-column').offset().top
				}, 800);
			}
		});

		//Listen for pagination clicks
		$(document).on('click', '.pagination .links a', function(e) {
			let newPage = $(this).attr('data-page');
			let oldPage = $('#paged').val();

			//Only change pages to a new page
			if (newPage != oldPage) {
				$('#paged').val(newPage);
				$('#filter-form').trigger('submit');
			}
		});

				// Mobile filter term reveal
		$( '.filter-sidebar-mobile' ).click( function( e ) {
			$( '.filter-sidebar' ).slideToggle( "slow" );
			$(this).toggleClass('active');
		});


	}

})(jQuery);
